import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=96108bd6&scoped=true"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"
import style0 from "./header2.vue?vue&type=style&index=0&id=96108bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96108bd6",
  null
  
)

export default component.exports